import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OrdersService } from 'src/app/_services/orders.service';
import { Order } from 'src/app/_models/order';
import { ToastrService } from 'ngx-toastr';
import { isUndefined } from 'util';
import { OrderLine } from '../../../_models/order';
//import { saveAs } from '../../../file-saver/FileSaver';
import {saveAs} from 'file-saver/dist/FileSaver';
import { BasketService } from 'src/app/_services/basket.service';

@Component({
  selector: 'app-user-orders',
  templateUrl: './user-orders.component.html',
  styleUrls: ['./user-orders.component.css']
})
export class UserOrdersComponent implements OnInit {

  constructor(
    public router : Router,
    public toastr : ToastrService,
    public ordersSrv : OrdersService,
    private activatedRoute : ActivatedRoute,
    private basket : BasketService
  ) { }

    public Orders : Order[];
    public OrderLines : OrderLine[];
    public NoHayPedidos : boolean;
    public VerDetalles : boolean;
    public Action : string;

  ngOnInit() {

    this.NoHayPedidos=true;
    this.VerDetalles=false;

    this.activatedRoute.pathFromRoot[2].url.subscribe(val => {
      this.Action = val[1].path;

      if (this.Action=="open"){
        this.ordersSrv.getOpenOrders().subscribe(res=>{
          this.Orders = res;
          if (isUndefined(this.Orders[0])) {
            this.NoHayPedidos=true;
          }else{
            this.NoHayPedidos=false;
          }
        });
      } else {
        this.ordersSrv.getClosedOrders().subscribe(res=>{
          this.Orders = res;
          if (isUndefined(this.Orders[0])) {
            this.NoHayPedidos=true;
          }else{
            this.NoHayPedidos=false;
          }
        });
      }
  

      });



  }

  mostrarDetalles(numPedido:number){
    this.ordersSrv.getOrderLines(numPedido).subscribe(res=>{
      this.OrderLines = res;
      this.VerDetalles=true;
    });
  }

  mostrarDetallesCerrada(factura:string){
    this.ordersSrv.getClosedOrderLines(factura).subscribe(res=>{
      this.OrderLines = res;
      this.VerDetalles=true;
    });
  }

  addToBasket(orderId : string) {
    this.basket.addFromOrder(orderId).subscribe()
  }

  downloadFactura(factura: string) {
    var blob = new Blob(["Hello, world!"], {type: "text/plain;charset=utf-8"});
    this.ordersSrv.downloadPDF(factura).subscribe( res=>{
      var blob = new Blob([res],{ type: 'application/pdf' });
      saveAs(blob, factura+".pdf");
    });
  }

  setAction(action:string){
    this.Action=action;
    this.VerDetalles=false;
  }

}
